import { Model } from "@/models";

export default class ClientAgency extends Model {
  static type = "clientsAgencies";

  name!: string;
}
